import { ApiError } from './api'
import { errorMessage } from '../core/errors'
import { isValidEmail } from '../core/rules/contact'

/**
 * De pure stukken van Mijn omgeving (`contexts/AccountContext.tsx`): vaste waarden, foutteksten
 * en hulpfuncties zonder React. Zo blijft de context over state en acties gaan.
 */

/** Bij een fout ook de foutcode en de veldfouten van de server, zodat het scherm ze bij het juiste veld zet. */
export type AuthResult = { ok: true } | { ok: false; error: string; code?: string; fields?: Record<string, string> }

/** Een verzoek uit de rij van een vorige sessie: niet verstuurd. Nooit aan de klant getoond. */
export class StaleSessionError extends Error {
  constructor() {
    super('Je sessie is gewisseld. Probeer het opnieuw.')
    this.name = 'StaleSessionError'
  }
}

/** De link in de mail wijst naar /account?inloglink=<token>. */
export const MAGIC_LINK_PARAM = 'inloglink'
/** De bevestigingsmail wijst naar /account?verifieer=<token>. */
export const VERIFY_PARAM = 'verifieer'
/** De mail van "wachtwoord vergeten" wijst naar /account?herstel=<token>. */
export const RESET_PARAM = 'herstel'
export const validEmail = isValidEmail
export const EMAIL_ERROR = 'Dit e-mailadres klopt niet helemaal.'
export const SIGNED_OUT_ERROR = 'Je bent uitgelogd. Log opnieuw in.'

export const messageOf = (err: unknown) =>
  (err instanceof ApiError ? errorMessage(err) : undefined) ?? 'Er ging iets mis. Probeer het nog eens.'

/** Een fout als AuthResult, met code en veldfouten als de server die meestuurde. */
export const failure = (err: unknown): AuthResult => ({
  ok: false,
  error: messageOf(err),
  code: err instanceof ApiError ? err.code : undefined,
  fields: err instanceof ApiError ? err.fields : undefined,
})

/** Toevoegen zonder dubbelen: een antwoord kan binnenkomen nadat een verse fetch het al bevatte. */
export const upsert = <T extends { id: string }>(list: T[], item: T) =>
  list.some((x) => x.id === item.id) ? list.map((x) => (x.id === item.id ? item : x)) : [...list, item]
